import { render, staticRenderFns } from "./tagView.vue?vue&type=template&id=070ef060&"
import script from "./tagView.vue?vue&type=script&lang=js&"
export * from "./tagView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports